<div class="bg-gray-200 rounded-lg w-full shadow p-2 mb-4">
    <div class="flex gap-2 overflow-x-auto whitespace-nowrap scrollbar-hide flex-nowrap">
    <a
      *ngFor="let tab of tabs"
      [routerLink]="tab.disabled ? null : [tab.route]"
      [queryParams]="tab.queryParams"
      routerLinkActive="bg-white text-gray-700 font-semibold"
      [routerLinkActiveOptions]="{ exact: false, matrixParams: 'ignored', queryParams: 'ignored', paths: 'subset', fragment: 'ignored' }"
      [class.opacity-50]="tab.disabled"
      [class.pointer-events-none]="tab.disabled"
      class="tab cursor-pointer">
      {{ tab.label | translate }}
    </a>
  </div>
</div>